import { SET_DEALER_DATA } from '../actions/types';

export default function dealerData(state = {}, action = null) {
	if (!action.error && action.payload && action.type) {
		switch (action.type) {
			case SET_DEALER_DATA:
				return { ...state, dealerData: action.payload };
			default:
				break;
		}
	}
	return state;
}
